export default __webpack_public_path__ + "static/1-318e795994beb5dcd3307b4f48a6c885.png";